import styled from "styled-components";

interface IShowLessMore {
  label?: string;
  count?: number;
  showLess?: boolean;
}

const ShowLessMore: React.FC<IShowLessMore> = (props: IShowLessMore) => {
  return (
    <Wrapper>
      {props.count ? (
        <span className="count">
          <>{props.showLess ? "" : <>{props.count > 9 ? "9+" : props.count}</>}</>
          <label className="more">{props.label}</label>
        </span>
      ) : (
        <span className="label">{props.label}</span>
      )}
    </Wrapper>
  );
};

export default ShowLessMore;

ShowLessMore.defaultProps = {
  label: "Show Less",
};

const Wrapper = styled.div`
  height: calc(100% - 50px);
  width: 100%;
  margin-bottom: 50px;
  position: relative;
  .count {
    font-family: "robotobold";
    font-weight: 700;
    font-size: 48px;
    color: #fff;
    height: 86px;
    width: 86px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 34px;
      height: 75px;
      width: 75px;
      padding-top: 20px;
    }
  }
  .more {
    font-family: "robotoregular";
    font-weight: 400;
    font-size: 20px;
    color: #fff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .label {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span {
    background-color: #7e7e7e;
    padding: 24px 20px;
    opacity: 0.5;
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    color: #ffffff;
    font-size: 20px;
    line-height: 19px;
    font-family: 'Roboto Slab', serif;
    max-width: 90px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
      padding: 12px 10px;
      max-width: 70px;
    }
  }
`;
